import { getDataMapper, mapField, getObjectId } from "@/shared";

export const mapRepairBreakingToServer = getDataMapper({
    broken_id: mapField("breaking", getObjectId),
    inventory_id: mapField("inventory", getObjectId),
});
